export default __webpack_public_path__ + "static/media/dragon.941cf783.png";